
import React, { useEffect, useState } from "react";
import MainLayout from "../layouts/MainLayout";
import '../assets/styles/loader.css';
import { fetchOrganizations } from './../services/organizationServices';
import { Select } from 'antd';
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { fetchModuleScreens, fetchRoleUsers } from "../services/roleMenuServices";
import { fetchWithAuth } from "../utils/api";

export default function RoleMenu() {

    const { Option } = Select;
    const [modules, setModules] = useState([]);
    const [filteredModules, setFilteredModules] = useState([]);
    const [sessionUserData, setsessionUserData] = useState({});
    const [rolesData, setRolesData] = useState([]);
    const [menuData, setMenuData] = useState([]);
    const [roleUsers, setRoleUsers] = useState([]);
    const [selectedOrgId, setSelectedOrgId] = useState(null);
    const [selectedRole, setSelectedRole] = useState(null);
    const [selectedModule, setSelectedModule] = useState(null);
    const [selectedScreen, setSelectedScreen] = useState(null);
    const [selectedRoleUser, setSelectedRoleUser] = useState(null);
    const [selectedUserDisplayIds, setSelectedUserDisplayIds] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [updateLoading, setUpdateLoading] = useState(false);
    const [organizationsData, setOrganizationsData] = useState([]);
    const [moduleScreens, setModuleScreens] = useState([]);
    const [userScreens, setUserScreens] = useState([]);
    const [actionEnums, setActionEnums] = useState([]);
    const [rowSelections, setRowSelections] = useState({});
    const [editRowId, setEditRowId] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const userDataString = sessionStorage.getItem("userData");
        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setsessionUserData(userData);
        } else {
            navigate("/");
        }
    }, [navigate]);

    const fetchModulesData = async () => {
        try {
            const response = await fetchWithAuth(`AdminRoutes/getModules`, {
                method: 'GET',
            });
            if (response.ok) {
                const data = await response.json();
                const allModules = data.ResultData || [];

                const filtered = allModules.filter(module => selectedUserDisplayIds.includes(module.Id));

                setModules(allModules);
                setFilteredModules(filtered);
            } else {
                console.error("Failed to fetch menu data:", response.statusText);
            }
        } catch (error) {
            console.error("Error fetching menu data:", error.message);
        }
    };

    useEffect(() => {
        if (selectedUserDisplayIds?.length > 0) {
            fetchModulesData();
        } else {
            setFilteredModules([]); // reset if none selected
        }
    }, [selectedUserDisplayIds]);

    const getOrganizations = async () => {
        try {
            const data = await fetchOrganizations();
            setOrganizationsData(data);
        } catch (error) {
            console.error('Failed to load organizations:', error);
        }
    };

    const getModuleScreens = async () => {
        try {
            const data = await fetchModuleScreens(selectedModule);
            setModuleScreens(data);
        } catch (error) {
            console.error('Failed to load departments:', error);
        }
    };

    const getRoleUsers = async () => {
        try {
            const data = await fetchRoleUsers(selectedOrgId, selectedRole);
            const usersByRole = data.filter(item => item.DDLName === 'UsersByRole');

            setRoleUsers(usersByRole);
        } catch (error) {
            console.error('Failed to load roleusers:', error);
        }
    };

    useEffect(() => {
        async function fetchActionEnums() {
            try {
                const response = await fetchWithAuth(`ADMINRoutes/CWIGetDDLItems?OrgId=0&UserId=0`, {
                    method: 'GET',
                });
                if (!response.ok) throw new Error("Network response was not ok");

                const data = await response.json();

                const filteredEnums = data.ResultData.filter(
                    (item) => item.DDLName === "ActionEnums"
                );

                const enumsFormatted = filteredEnums.map((item) => ({
                    label: item.DisplayValue,
                    value: item.ItemId,
                }));

                setActionEnums(enumsFormatted);
            } catch (error) {
                console.error("Failed to fetch ActionEnums:", error);
            }
        }

        fetchActionEnums();
    }, []);

    useEffect(() => {
        getOrganizations();
        fetchModulesData();
    }, []);

    useEffect(() => {
        if (selectedModule) {
            getModuleScreens();
        }
    }, [selectedModule]);

    useEffect(() => {
        if (sessionUserData && selectedRole && sessionUserData?.Id) {
            getRoleUsers();
        }
    }, [selectedRole]);

    const fetchRolesData = async () => {
        if (selectedOrgId) {
            try {
                const response = await fetchWithAuth(`AdminRoutes/getRoles?OrgId=9333`, {
                    method: 'GET',
                });
                if (response.ok) {
                    const data = await response.json();
                    setRolesData(data.ResultData);
                } else {
                    console.error('Failed to fetch attendance data:', response.statusText);
                }
            } catch (error) {
                console.error('Error fetching attendance data:', error.message);
            }
        }
    };

    useEffect(() => {
        if (selectedOrgId) {
            fetchRolesData();
        }
    }, [selectedOrgId]);

    const fetchUserScreensData = async () => {
        if (selectedOrgId) {
            try {
                const response = await fetchWithAuth(`ADMINRoutes/ScreensByUserId?ModuleId=${selectedModule}&UserId=${selectedRoleUser}&OrgId=${selectedOrgId}`, {
                    method: 'GET',
                });
                if (response.ok) {
                    const data = await response.json();
                    setUserScreens(data.ResultData);

                    const selectionMap = {};
                    data.ResultData.forEach((menu) => {
                        selectionMap[menu.Id] = menu.ActionsIds?.split(',').map(Number) || [];
                    });
                    setRowSelections(selectionMap);
                } else {
                    console.error('Failed to fetch attendance data:', response.statusText);
                }
            } catch (error) {
                console.error('Error fetching attendance data:', error.message);
            }
        }
    };

    useEffect(() => {
        if (selectedModule && selectedRoleUser) {
            fetchUserScreensData();
        }
    }, [selectedModule, selectedRoleUser]);

    const handleScreenSelect = (screenId) => {
        const existingIds = Array.isArray(userScreens) ? userScreens.map((s) => String(s.Id)) : [];

        if (screenId === 'ALL') {
            const newScreens = moduleScreens.filter((s) => !existingIds.includes(String(s.Id)));

            const newRows = newScreens.map((screen) => ({
                Id: screen.Id,
                MenuName: screen.MenuName,
                // 👇 keep allowed actions from service
                ActionIds: screen.ActionIds,
                IsNew: true,
            }));

            if (newRows.length > 0) {
                setUserScreens((prev) =>
                    Array.isArray(prev) ? [...prev, ...newRows] : [...newRows]
                );

                const newSelections = {};
                newScreens.forEach((screen) => {
                    newSelections[screen.Id] = [];
                });

                setRowSelections((prev) =>
                    typeof prev === 'object' && prev !== null ? { ...prev, ...newSelections } : newSelections
                );
            }
        } else {
            const screen = moduleScreens?.find((s) => String(s.Id) === String(screenId));
            if (!screen) return;

            const exists = existingIds.includes(String(screen.Id));
            if (!exists) {
                const newRow = {
                    Id: screen.Id,
                    MenuName: screen.MenuName,
                    // 👇 keep allowed actions from service
                    ActionIds: screen.ActionIds,
                    IsNew: true,
                };

                setUserScreens((prev) =>
                    Array.isArray(prev) ? [...prev, newRow] : [newRow]
                );
                setRowSelections((prev) =>
                    typeof prev === 'object' && prev !== null
                        ? { ...prev, [screen.Id]: [] }
                        : { [screen.Id]: [] }
                );
            }
        }

        setSelectedScreen(null);
    };

    // const handleActionChange = (menuId, values) => {
    //     // 1. Get existing enums already assigned to this screen
    //     const existingEnums = rowSelections[menuId] || [];
    //     console.log('existing:', existingEnums)
    
    //     // 2. Find newly added enums (compare with existing ones)
    //     const newlyAdded = values.filter(v => !existingEnums.includes(v));
    //     console.log('newly',newlyAdded)
    
    //     // 3. Find duplicates (values that were already assigned before)
    //     const duplicates = newlyAdded.filter(v => existingEnums.includes(v));
    //     console.log('dup', duplicates)
    
    //     if (duplicates.length > 0) {
    //         Swal.fire({
    //             icon: "warning",
    //             title: "Already Assigned",
    //             text: `The enum(s) ${duplicates.join(", ")} are already assigned to this screen.`,
    //         });
    //     }
    
    //     // 4. Update state (but keep only unique enums)
    //     setRowSelections((prev) => ({
    //         ...prev,
    //         [menuId]: Array.from(new Set(values)), // remove accidental duplicates
    //     }));
    // };   

    const handleActionChange = (menuId, values) => {
        const existingEnums = rowSelections[menuId] || [];
    
        // 🔹 Find what user just tried to add (difference in array lengths)
        const lastSelected = values.find(v => !existingEnums.includes(v));
    
        // 🔹 If they tried to add something already in existingEnums → it's a duplicate
        if (lastSelected === undefined && values.length >= existingEnums.length) {
            const duplicates = values.filter(v => existingEnums.includes(v));
            if (duplicates.length > 0) {
                Swal.fire({
                    icon: "warning",
                    title: "Already Assigned",
                    text: `This enum was already assigned to this screen.`,
                });
            }
        }
    
        // ✅ Update state (unique values only)
        setRowSelections((prev) => ({
            ...prev,
            [menuId]: Array.from(new Set(values)),
        }));
    };

    const handleEdit = (id) => setEditRowId(id);

    const handleSave = async (menuId) => {
        const selectedIds = rowSelections[menuId] || [];
        const screenRow = userScreens.find((row) => row.Id === menuId);

        const isNew = screenRow?.IsNew;
        const endpoint = isNew
            ? `ADMINRoutes/AddRoleMenu`
            : `ADMINRoutes/EditRoleMenu`;

        const payload = isNew
            ? {
                OrgId: selectedOrgId,
                RoleId: selectedRole,
                UserId: selectedRoleUser,
                AppMenuId: menuId,
                ActionsIds: selectedIds.join(','),
                CreatedBy: sessionUserData?.Id,
            }
            : {
                OrgId: selectedOrgId,
                RoleId: selectedRole,
                UpdatedBy: sessionUserData?.Id,
                UserId: selectedRoleUser,
                RoleMenuId: screenRow.Id,
                ActionsIds: selectedIds.join(','),
            };

        try {
            const res = await fetchWithAuth(endpoint, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });

            const data = await res.json();

            if (data.ResultData.Status === 'Success') {
                // If new screen, update it to mark not new and store RoleMenuId from response
                if (isNew) {
                    // setUserScreens((prev) =>
                    //     prev.map((row) =>
                    //         row.Id === menuId
                    //             ? {
                    //                   ...row,
                    //                   IsNew: false,
                    //                   RoleMenuId: data.ResultData.RoleMenuId,
                    //                   ActionsIds: selectedIds.join(','),
                    //               }
                    //             : row
                    //     )
                    // );
                } else {
                    setUserScreens((prev) =>
                        prev.map((row) =>
                            row.Id === menuId ? { ...row, ActionsIds: selectedIds.join(',') } : row
                        )
                    );
                }

                setEditRowId(null);
            } else {
                console.error('Save failed:', data);
            }
        } catch (err) {
            console.error('Error saving:', err);
        }
    };

    const handleDelete = async (menuId) => {
        Swal.fire({
          title: "Are you sure?",
          text: "This action will inactivate the menu!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "No, cancel"
        }).then(async (result) => {
          if (result.isConfirmed) {
            const endpoint = `ADMINRoutes/InActiveRoleMenu`;
            const payload = { Id: menuId };
      
            try {
              const res = await fetchWithAuth(endpoint, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
              });
      
              const data = await res.json();
      
              if (data.ResultData.Status === "Success") {
                Swal.fire("Deleted!", "Menu has been inactivated.", "success").then(() => fetchUserScreensData())
              } else {
                Swal.fire("Error!", "Something went wrong.", "error");
                console.error("Save failed:", data);
              }
            } catch (err) {
              Swal.fire("Error!", "Failed to delete. Try again.", "error");
              console.error("Error saving:", err);
            }
          }
        });
      };

    const handleCancel = (menuId) => {
        // Find the screen row again
        const screenRow = userScreens.find((row) => row.Id === menuId);

        setRowSelections((prev) => ({
            ...prev,
            [menuId]: screenRow?.ActionsIds?.split(',').map(Number) || [],
        }));

        // Exit edit mode
        setEditRowId(null);
    };

    useEffect(() => {
        if (Array.isArray(userScreens) && moduleScreens?.length) {
            const enriched = userScreens.map((scrn) => {
                // Find this screen in moduleScreens
                const fullScreen = moduleScreens.find((m) => String(m.Id) === String(scrn.Id));
                return {
                    ...scrn,
                    ActionIds: scrn.ActionIds || fullScreen?.ActionIds || "", // 👈 ensure ActionIds always present
                };
            });
            setUserScreens(enriched);
        }
    }, [moduleScreens]);

    return (
        <MainLayout>
            <div className="content">
                <div className="page-header">
                    <div className="add-item d-flex">
                        <div className="page-title">
                            <h4 className="fw-bold">Role Menu</h4>
                            <h6>Manage your Menu Items</h6>
                        </div>
                    </div>
                    <ul className="table-top-head">
                        <li>
                            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Refresh"><i className="ti ti-refresh"></i></a>
                        </li>
                        <li>
                            <button type="button" className="btn btn-primary btn-sm" title="Add screen">Add</button>
                        </li>
                    </ul>
                </div>
                {updateLoading && (
                    <div
                        style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100vw',
                            height: '100vh',
                            backgroundColor: 'rgba(255, 255, 255, 0.6)',
                            backdropFilter: 'blur(4px)',
                            zIndex: 9999,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                )}

                <div className="card">
                    <div className="card-body">
                        <div className="row align-items-end">
                            <div className="col-md-3 col-lg-3 col-12 mb-2">
                                <label className="form-label">Organization<span className="text-danger">*</span></label>
                                <Select
                                    showSearch
                                    placeholder="Choose Organization"
                                    className="w-100"
                                    value={selectedOrgId}
                                    onChange={(value) => setSelectedOrgId(value)}
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().includes(input.toLowerCase())
                                    }
                                >
                                    {organizationsData?.map((org) => (
                                        <Option key={org.OrgId} value={org.OrgId}>
                                            {org.OrgName}
                                        </Option>
                                    ))}
                                </Select>
                            </div>

                            <div className="col-md-2 col-lg-2 col-12 mb-2">
                                <label className="form-label">Role<span className="text-danger">*</span></label>
                                <Select
                                    showSearch
                                    placeholder="Choose Role"
                                    className="w-100"
                                    value={selectedRole}
                                    onChange={(value) => setSelectedRole(value)}
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().includes(input.toLowerCase())
                                    }
                                >
                                    {rolesData?.map((role) => (
                                        <Option key={role.Id} value={role.Id}>
                                            {role.Name}
                                        </Option>
                                    ))}
                                </Select>
                            </div>

                            <div className="col-md-3 col-lg-3 col-12 mb-2">
                                <label className="form-label">Users<span className="text-danger">*</span></label>
                                <Select
                                    showSearch
                                    placeholder="Choose user"
                                    className="w-100"
                                    value={selectedRoleUser || null}
                                    onChange={(value) => {
                                        setSelectedRoleUser(value);

                                        const selectedUser = roleUsers.find(user => user.ItemId === value);
                                        if (selectedUser) {
                                            const displayValueIds = selectedUser.DisplayValue?.split(',').map(id => Number(id));
                                            // console.log("DisplayValue IDs:", displayValueIds);

                                            setSelectedUserDisplayIds(displayValueIds);
                                        }
                                    }}
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().includes(input.toLowerCase())
                                    }
                                >
                                    {roleUsers?.map((mod) => (
                                        <Option key={mod.ItemId} value={mod.ItemId}>
                                            {mod.ItemValue}
                                        </Option>
                                    ))}
                                </Select>
                            </div>
                            <div className="col-md-2 col-lg-2 col-12 mb-2">
                                <label className="form-label">Modules<span className="text-danger">*</span></label>
                                <Select
                                    showSearch
                                    placeholder="Choose Module"
                                    className="w-100"
                                    value={selectedModule}
                                    onChange={(value) => setSelectedModule(value)}
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().includes(input.toLowerCase())
                                    }
                                >
                                    {filteredModules?.map((mod) => (
                                        <Option key={mod.Id} value={mod.Id}>
                                            {mod.ModuleName}
                                        </Option>
                                    ))}
                                </Select>
                            </div>
                            <div className="col-md-2 col-lg-2 col-12 mb-2">
                                <label className="form-label">Screens <span className="text-danger">*</span></label>
                                <Select
                                    showSearch
                                    placeholder="Choose Screen"
                                    className="w-100"
                                    value={selectedScreen}
                                    onChange={handleScreenSelect}
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().includes(input.toLowerCase())
                                    }
                                >
                                    <Option key="ALL" value="ALL">Select All</Option>
                                    {moduleScreens?.map((scrn) => (
                                        <Option key={scrn.Id} value={scrn.Id}>
                                            {scrn.MenuName}
                                        </Option>
                                    ))}
                                </Select>
                            </div>
                        </div>
                        <div className="table-responsive">
                            <table className={`table`}>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Screen</th>
                                        <th>Selected Enum's</th>
                                        <th>Available Enum's</th>
                                        <th>Action</th>
                                        <th>Remove</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {isLoading ? (
                                        <tr>
                                            <td colSpan="6" className="text-center">
                                                <div className="container" ></div>
                                            </td>
                                        </tr>
                                    ) : selectedRole ? (
                                        userScreens?.length > 0 ? (
                                            userScreens?.map((menu, index) => {
                                                const selectedValues = rowSelections[menu.Id] || [];
                                                const isEditing = editRowId === menu.Id;

                                                return (
                                                    <tr key={menu.Id}>
                                                        <td>{index + 1}</td>
                                                        <td>{menu.MenuName}</td>
                                                        <td>
                                                            <Select
                                                                mode="multiple"
                                                                disabled={!isEditing}
                                                                className="w-100"
                                                                value={selectedValues}
                                                                onChange={(values) => handleActionChange(menu.Id, values)}
                                                            >
                                                                {actionEnums
                                                                    .filter((op) => selectedValues.includes(op.value))
                                                                    .map((op) => (
                                                                        <Select.Option key={op.value} value={op.value}>
                                                                            {op.label}
                                                                        </Select.Option>
                                                                    ))}
                                                            </Select>
                                                        </td>
                                                        <td>
                                                            <Select
                                                                mode="multiple"
                                                                disabled={!isEditing}
                                                                className="w-100"
                                                                placeholder="Add more"
                                                                value={rowSelections[menu.AppMenuId] || []}// keep empty so user only adds new ones
                                                                onChange={(values) =>
                                                                    handleActionChange(menu.Id, [...selectedValues, ...values])
                                                                }
                                                            >
                                                                {(() => {
                                                                    // ✅ works for both existing and new
                                                                    const screenId = menu.AppMenuId || menu.Id;

                                                                    const fullScreen = moduleScreens.find(m => String(m.Id) === String(screenId));

                                                                    const allowedIds = fullScreen?.ActionIds
                                                                        ? fullScreen.ActionIds.split(",").map(id => id.trim())
                                                                        : (menu.ActionIds ? menu.ActionIds.split(",").map(id => id.trim()) : []);

                                                                    // Instead of filtering out already selected → include them but mark as disabled
                                                                    return actionEnums
                                                                        .filter(op => allowedIds.includes(String(op.value)))
                                                                        .map(op => (
                                                                            <Select.Option
                                                                                key={op.value}
                                                                                value={op.value}
                                                                                disabled={selectedValues.includes(String(op.value))} // 👈 disable already assigned
                                                                            >
                                                                                {op.label}
                                                                            </Select.Option>
                                                                        ));
                                                                })()}
                                                            </Select>
                                                        </td>
                                                        <td>
                                                            {isEditing ? (
                                                                <>
                                                                    <button
                                                                        className="btn btn-sm"
                                                                        onClick={() => handleSave(menu.Id)}
                                                                    >
                                                                        <i className="fa-solid fa-floppy-disk fa-lg text-success"></i>
                                                                    </button>

                                                                    <button
                                                                        className="btn btn-sm ms-2"
                                                                        onClick={() => handleCancel(menu.Id)}
                                                                    >
                                                                        <i className="fa-solid fa-xmark fa-lg text-danger"></i>
                                                                    </button>
                                                                </>
                                                            ) : (
                                                                <button
                                                                    className="btn btn-sm"
                                                                    onClick={() => handleEdit(menu.Id)}
                                                                >
                                                                    <i className="fa-solid fa-pen-to-square fa-lg text-primary"></i>
                                                                </button>
                                                            )}
                                                        </td>
                                                        <td>
                                                            <button
                                                                className="btn btn-sm"
                                                                onClick={() => handleDelete(menu.Id)}
                                                            >
                                                                <i className="fa-regular fa-trash-can fa-lg text-danger"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        ) : (
                                            <tr>
                                                <td colSpan="6" className="text-center">
                                                    No data available for the selected details.
                                                </td>
                                            </tr>
                                        )
                                    ) : (
                                        <tr>
                                            <td colSpan="6" className="text-center">
                                                Please select organization, role & module to view the data.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
            </div>
        </MainLayout>

    )
}